import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";

class PromptModal extends PureComponent {
	render() {
		return (
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-prompt-modal"
			}}
				open={this.props.promptModal.visible}
				showCloseIcon={false}
				onEntered={this.onModalEntered}
				onClose={() => { }}>		
				<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
					<div style={{ position: "absolute", top: 0, left: 0, width: "50%", height: 100 }}>
						{this.props.embeddedTimer}
					</div>
					<div style={{ color: "white", fontSize: 32, margin: 50 }}>{this.props.promptModal.text}</div>
					<div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
						<div style={{ color: "tomato", borderColor: "tomato", borderStyle: "solid", borderRadius: "10px", fontSize: 24, marginRight: "15px", padding: "25px 25px 25px 25px", cursor: "pointer"}} onClick={() => { this.props.negativeAction(); }}>Negative</div>							
						<div style={{ color: "lightgreen", borderColor: "lightgreen", borderStyle: "solid", borderRadius: "10px", fontSize: 24, marginLeft: "15px", padding: "25px 25px 25px 25px", cursor: "pointer" }} onClick={() => { this.props.affirmativeAction(); }}>Affirmative</div>							
					</div>					
				</div>
			</Modal>
		);
	}
}

export default branch({
	promptModal: ["appState", "promptModal"]
}, PromptModal);
